import React from 'react';
export class SelectItem extends React.Component {
    constructor(props) {
        super(props);
    }

    render(){
        return(
            <option value={this.props.value}>{this.props.title}</option>
        )
    }
}
export default SelectItem;
